import type { ReactNode } from 'react';

interface SettingsSectionProps {
  eyebrow: string;
  title: string;
  subtitle?: string;
  children: ReactNode;
}

export const SettingsSection = (props: SettingsSectionProps) => (
  <div className="mt-[28px] pt-[24px] border-t border-solid border-[var(--hair)]">
    <div className="flex flex-col gap-[16px] desktop:grid desktop:grid-cols-[200px_1fr] desktop:gap-[32px]">
      <div>
        <div className="mb-[4px] text-[11px] tracking-[0.14em] uppercase font-normal text-[var(--fg-3)]">
          {props.eyebrow}
        </div>
        <div
          className="text-[20px] text-[var(--fg)]"
          style={{ fontFamily: 'var(--font-display)' }}
        >
          {props.title}
        </div>
        {props.subtitle && (
          <div className="text-[12px] text-[var(--fg-3)] mt-[6px] leading-[1.5]">
            {props.subtitle}
          </div>
        )}
      </div>
      <div>{props.children}</div>
    </div>
  </div>
);
